export default __webpack_public_path__ + "static/media/aparatwhite.9237cd08.svg";